// extracted by mini-css-extract-plugin
export default {"rectangleImage":"Image_rectangleImage__UkBDp","roundImage":"Image_roundImage__y6r4t"};